import React, { useState } from 'react';
import { Button, SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';
import DateIssuedIcon from '../../../../icons/dateIssued.svg?react';
import ButtonCardWithFunction from '../../../Helpers/Buttons/ButtonCardWithFunction';
import TermLengthCalculator from './TermLengthCalculator';
import './TermLengthCalc.scss'

export default function TermLengthButton(props) {

  const shape = props.shape ? props.shape : 'wide';

  const title = props.title || "NEEDS ANALYSIS";
  const icon = props.icon || <SvgIcon component={DateIssuedIcon}/>;

  const [modalTermLengthCalculatorIsOpen, setModalTermLengthCalculatorIsOpen] = useState(false);

  const modalTermLengthCalculatorFields = {
    modalTermLengthCalculatorIsOpen: modalTermLengthCalculatorIsOpen,
    setModalTermLengthCalculatorIsOpen: setModalTermLengthCalculatorIsOpen,
    insuredAge: props.insuredAge
  };

  const redirectToTermLength = () => {
    setModalTermLengthCalculatorIsOpen(true);
  };

  return (
    <div className="terms-analysis-button needs-analysis-button">
      <React.Fragment>
        {props.type === "quote-screen" ?
          <Button type="submit"
                  onClick={() => setModalTermLengthCalculatorIsOpen(true)}
                  variant={props.isPrequote ? undefined : "contained"}
                  color="primary"
                  className={`${props.isPrequote ? "button-primary" : `quote-terms-button button-primary`}`}
          >
            {props.isPrequote ? <SvgIcon component={DateIssuedIcon} color="primary"/> :
              <div className={`icon-container mb-0 background-color-16`}><SvgIcon component={DateIssuedIcon}
                                                                                         color="primary"/></div>}
            <span className="name">&nbsp;{title}</span>
          </Button>
          :
          <ButtonCardWithFunction id={0}
                                  name={title}
                                  onClick={redirectToTermLength}
                                  shape={shape}
                                  icon={icon}
                                  className="button-primary"
                                  isFromHomePage={props.isFromHomePage}
          />
        }
        <TermLengthCalculator
          fields={modalTermLengthCalculatorFields}
          onTermLengthCalculation={props.onTermLengthCalculation}
          isPrequote={props.isPrequote}
          isCustomTerm={props.isCustomTerm}
        />
      </React.Fragment>
    </div>
  );
}

TermLengthButton.propTypes = {
  shape: PropTypes.string,
};
